/* eslint-env es6 */
export const keyWord = state => state.keyWord
export const channelBrand = state => state.channelBrand
export const liveShopId = state => state.liveShopId
